module.exports = __webpack_public_path__ + "static/couatl-2f548e42300755ad4b5437f0e6519e14.png";